/** User-facing copy for X-Plan-Warning header values. */
export function planWarningMessage(code: string | null, plan = 'free'): string | null {
  if (!code) return null;
  const label = plan.charAt(0).toUpperCase() + plan.slice(1);
  if (code === 'subscription_expired') {
    return 'Your subscription has expired. Contact support to renew access.';
  }
  if (code === 'notification_quota_exceeded') {
    return 'Daily notification limit reached for your plan.';
  }
  if (code === 'quota_scrape_interval') {
    return 'Please wait before running another scrape for this search.';
  }
  if (code === 'plan_limit_exceeded' || code.startsWith('quota_') || code === 'quota_exceeded') {
    return `${label} plan limit reached. Upgrade or contact support.`;
  }
  if (code === 'plan_limit_near') {
    return `You are near your ${label} plan limit.`;
  }
  return null;
}

export function entitlementStatusMessage(
  usage: {
    subscriptionActive?: boolean;
    unlimited?: boolean;
    planSlug?: string | null;
    expiresAt?: string | null;
    limits?: { maxSearches?: number | null };
    usage?: { activeSearches?: number };
  },
  options?: { canActOnSearchQuota?: boolean },
): string | null {
  if (usage.unlimited) {
    return null;
  }
  if (!usage.subscriptionActive) {
    return 'Your organization subscription is inactive. Searches may be paused until a plan is granted.';
  }
  const max = usage.limits?.maxSearches;
  const used = usage.usage?.activeSearches ?? 0;
  if (max != null && used >= max) {
    if (options?.canActOnSearchQuota === false) {
      return null;
    }
    return `Search quota exceeded (${used}/${max}). Disable or archive a search before creating new ones.`;
  }
  if (usage.expiresAt) {
    const days = (new Date(usage.expiresAt).getTime() - Date.now()) / (1000 * 60 * 60 * 24);
    if (days > 0 && days <= 5) {
      return `Your plan expires in ${Math.ceil(days)} day(s).`;
    }
  }
  return null;
}

export function quotaErrorMessage(err: unknown): string | null {
  if (!err || typeof err !== 'object') return null;
  const detail = (err as { detail?: { message?: string; code?: string } }).detail;
  if (detail?.message) return detail.message;
  return null;
}
